import { Component, OnInit, ElementRef, Renderer2, DestroyRef, ViewChild, HostBinding, inject, input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ISpeechToTextTranscriptChunk } from "../../../../../core-ui/models/interfaces";
import { ThemeService } from "../../../../../core-ui/services/theme.service";
import { ConferenceService } from "../../../../../core-ui/services/conference.service";
import { IEndpoint } from "@auvious/rtc";
import { IEndpointMetadata } from "../../../../../core-ui/models/IEndpointState";
import { UserRoleEnum } from "../../../../../core-ui/core-ui.enums";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "../../../../../core-ui/services/user.service";
import { DeviceService } from "../../../../../core-ui/services/device.service";

@Component({
  selector: "app-caption-item",
  templateUrl: "./item.component.html",
  styleUrls: ["./item.component.scss"],
  standalone: false,
})
export class CaptionItemComponent implements OnInit {
  private theme = inject(ThemeService);
  private destroyRef = inject(DestroyRef);
  private host = inject<ElementRef<HTMLDivElement>>(ElementRef);
  private renderer = inject(Renderer2);
  private conference = inject(ConferenceService);
  private t = inject(TranslateService);
  private user = inject(UserService);

  readonly chunk = input<ISpeechToTextTranscriptChunk>(undefined);
  // @ViewChild('transcript') transcriptRef: ElementRef<HTMLDivElement>;

  endpoint: IEndpoint;

  @HostBinding("class") get class() {
    return {
      mobile: DeviceService.isMobile,
    };
  }

  ngOnInit(): void {
    this.endpoint = this.findParticipantByUsername(this.chunk()?.userId);

    this.theme.themeChanged$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((theme) => {
      if (!theme) {
        return;
      }
      this.renderer.setStyle(
        this.host.nativeElement,
        "background-color",
        theme.captionsFontBackgroundColor
      );
    });
  }

  trackChunk(index, el: ISpeechToTextTranscriptChunk) {
    return el.userId + el.transcript;
  }

  get username(): string {
    const metadata = this.endpoint?.metadata;
    if (!metadata) {
      return "Me";
    }
    const role = metadata.roles.includes(UserRoleEnum.agent)
      ? this.t.instant("Agent")
      : this.t.instant("Customer");
    return metadata.name || role;
  }

  get imgUrl() {
    if (this.conference.myself.username === this.chunk().userId) {
      return this.user.getUserDetails()?.avatarUrl;
    }
    return this.endpoint?.metadata?.avatarUrl;
  }

  get initials() {
    return !!this.username ? this.username[0] : "?";
  }

  private findParticipantByUsername(id: string): IEndpoint {
    const participants = this.conference.getParticipants();
    const pKey = Object.keys(participants).find(
      (key) => participants[key].username === id
    );
    if (!pKey) {
      return;
    }
    return participants[pKey];
  }
}
